<template>
  <b-container fluid>
    <b-row>
      <b-col class="p-4">
        <h2 class="text-left">External Links
          <span class="float-right">
            <course-link-form v-on:ok="addLink" :text="'Add Link'" :link="newLink" :pvariant="'primary'"></course-link-form>
          </span>
        </h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="p-4">
        <b-input-group>
          <b-form-input
            v-model="searchText"
            placeholder="Search"
            type="text">
          </b-form-input>
          <b-input-group-append>
            <b-button v-on:click="searchText = ''"><b-icon-x></b-icon-x></b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-left">
        <b-button size="sm" variant="link" @click="selectAllRows" :disabled="links.length === 0">Select all</b-button>
        <b-button size="sm" variant="link" @click="clearSelected" :disabled="selectedRows.length === 0">Clear selected</b-button>
        <b-button size="sm" variant="link" @click="removeItems" :disabled="selectedRows.length === 0">Remove</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="p-4">
        <b-table small
        ref="selectableTable"
        :items="filteredLinks"
        :fields="fields"
        :busy="loading"
        @row-selected="onRowSelected"
        selectable
        select-mode="range"
        class="text-left"
        >
          <template v-slot:table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template v-slot:cell(title)="data">
            {{data.value}}
          </template>

          <template v-slot:cell(link)="data">
            <b-button :href="data.value" target="_blank" variant="link">{{data.value}}</b-button>
          </template>

          <template v-slot:cell(actions)="data">
            <course-link-form v-on:ok="addLink" :text="'Edit Link'" :link="data.item" :pvariant="'link'" style="display: inline;"></course-link-form>
            <b-button variant="link" @click="deleteLink(data.item)" style="display: inline;">Delete</b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Api from '@/api/Api'
import CourseLinkForm from './CourseLinkForm'

export default {
  props: [ 'id' ],
  data () {
    return {
      loading: false,
      fields: [ { key: 'title', label: 'Title' }, { key: 'link', label: 'URL' }, { key: 'actions', label: '' } ],
      links: [],
      newLink: {
        id: 0,
        title: '',
        link: ''
      },
      searchText: '',
      selectedRows: []
    }
  },
  computed: {
    filteredLinks () {
      return this.searchText
        ? this.links.filter(item => item.title.includes(this.searchText) || item.link.includes(this.searchText))
        : this.links
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      var vm = this
      vm.loading = true
      Api().get(`Course/${vm.id}/Links`)
        .then((r) => {
          vm.links = r.data
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          vm.loading = false
        })
    },
    addLink (result) {
      var vm = this
      vm.loading = true
      if (result.id > 0) {
        Api().put(`Course/${vm.id}/Links/${result.id}`, result)
          .then((r) => {
            vm.links.splice(vm.links.findIndex((i) => i.id === result.id), 1, r.data)
            vm.newLink = {
              id: 0,
              title: '',
              link: ''
            }
          })
          .catch((e) => {
            console.log(e)
          })
          .finally(() => {
            vm.loading = false
          })
      } else {
        Api().post(`Course/${vm.id}/Links`, result)
          .then((r) => {
            vm.links.push(r.data)
            vm.newLink = {
              id: 0,
              title: '',
              link: ''
            }
          })
          .catch((e) => {
            console.log(e)
          })
          .finally(() => {
            vm.loading = false
          })
      }
    },
    deleteLink (link) {
      var vm = this
      this.$bvModal.msgBoxConfirm('Are you sure you want to remove this link?', {
        title: 'Remove Link from course',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if (value) {
            vm.loading = true
            Api().delete(`Course/${vm.id}/Links/${link.id}`)
              .then((r) => {
                vm.links.splice(vm.links.findIndex((n) => n.id === link.id), 1)
              })
              .catch((e) => {
                console.log(e)
              })
              .finally(() => {
                vm.loading = false
              })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    onRowSelected (items) {
      this.selectedRows = items
    },
    selectAllRows () {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected () {
      this.$refs.selectableTable.clearSelected()
    },
    removeItems () {
      var vm = this
      vm.loading = true
      var all = vm.selectedRows.map((i) => { return Api().delete(`Course/${vm.id}/Links/${i.id}`) })
      Promise.all(all)
        .then(() => {
          vm.loadData()
        })
        .catch((e) => {
          console.log(e)
        })
    }
  },
  components: {
    CourseLinkForm
  }
}
</script>

<style>

</style>
